const budget = {
  state: {
    basicParams: {}, // 步骤1的基础信息对象
    budgetDetails: {}, // 步骤2存的接口返回的结果集,
    isImport: false, // 若是导入的数据，则表格显示校验结果此列为true,默认为false
    isState: 'add', // 判断是添加还是修改年度预算 默认添加为'add',修改为'edit'
    fileIds: [] // 点击编辑进入第一步存起来附件id集
  },
  getters: {
    basicParams: state => {
      return state.basicParams
    },
    budgetDetails: state => {
      return state.budgetDetails
    },
    isImport: state => {
      return state.isImport
    },
    isState: state => {
      return state.isState
    },
    fileIds: state => {
      return state.fileIds
    }
  },
  mutations: {
    SET_BASICPARAMS (state, basicParams) {
      state.basicParams = basicParams
    },
    SET_BUDGETDETAILS (state, budgetDetails) {
      state.budgetDetails = budgetDetails
    },
    SET_ISIMPORT (state, isImport) {
      state.isImport = isImport
    },
    SET_ISSTATE (state, isState) {
      state.isState = isState
    },
    SET_FILEIDS (state, fileIds) {
      state.fileIds = fileIds
    }
  },
  actions: {}
}

export default budget



// WEBPACK FOOTER //
// ./src/store/modules/budget.js